<template>
  <b-modal
    ref="modal"
    :title="`Settings ${url ? 'for ' + url : ''}`"
    @ok="onSaveClick"
    @hidden="onHide"
    @cancel="onHide"
    ok-variant="success"
    :okDisabled="isLoading"
  >
    <template slot="modal-ok"> Save</template>
    <form v-on:submit="onSave" class="kt-form kt-form--label-right">
      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label"
          >Select domain for copy settings</label
        >
        <div class="col-lg-9 col-xl-6 redirect-select">
          <v-select
            :options="list"
            :getOptionLabel="(option) => option.domain"
            placeholder="Select domain"
            :value="settingsForCopy"
            @input="
              (newValue) => {
                settingsForCopy = newValue;
              }
            "
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                v-bind="attributes"
                v-on="events"
                @input="(e) => onChangeSearchDomain(e)"
                v-model="search_domains"
              />
            </template>
          </v-select>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">Redirect URL*</label>
        <div class="col-lg-9 col-xl-6">
          <input class="form-control" v-model="redirect_url" required />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">Type</label>
        <div class="col-lg-9 col-xl-6 redirect-select">
          <v-select
            :options="flowOptions"
            :clearable="false"
            placeholder="Select flow"
            :value="redirect_flow"
            :filterable="false"
            :searchable="false"
            @input="
              (newValue) => {
                redirect_flow = newValue;
              }
            "
          >
          </v-select>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label"
          >Redirect Percent*</label
        >
        <div class="col-lg-9 col-xl-6">
          <input
            class="form-control"
            v-model="redirect_percent"
            min="0"
            max="100"
            type="number"
            required
          />
        </div>
      </div>

      <div v-if="redirect_flow === 'delay'" class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">Delay*</label>
        <div class="col-lg-9 col-xl-6">
          <input class="form-control" v-model="redirect_delay" required />
        </div>
      </div>

      <div v-if="redirect_flow === 'scroll'" class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label"
          >Scroll percentage*</label
        >
        <div class="col-lg-9 col-xl-6">
          <input class="form-control" v-model="scroll_percentage" required />
        </div>
      </div>

      <div v-if="redirect_flow === 'click'" class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">Selector*</label>
        <div class="col-lg-9 col-xl-6">
          <input class="form-control" v-model="click_selector" required />
        </div>
      </div>
      <div v-if="redirect_flow === 'show'" class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">Selector*</label>
        <div class="col-lg-9 col-xl-6">
          <input class="form-control" v-model="show_selector" required />
        </div>
      </div>

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">Enable</label>
        <div class="col-lg-9 col-xl-6">
          <label class="checkbox">
            <input type="checkbox" v-model="enabled" />
            <span></span
          ></label>
        </div>
      </div>
      <div class="form-group row mb-0">
        <label class="col-xl-4 col-lg-3 col-form-label">Tags</label>
        <div class="col-lg-9 col-xl-6">
          <tags ref="tags" :tags="tags" />
        </div>
      </div>

      <button ref="ModalSubmit" type="submit" class="kt-hidden d-none" />
    </form>
  </b-modal>
</template>

<script>
import vSelect from "vue-select";
import { mapActions, mapState } from "vuex";
import * as TYPES from "@/core/services/store/modules/domains/types";
import { debounce } from "@/core/services/services";
import Tags from "../../../content/Tags";

export default {
  name: "DomainSettings",
  components: { vSelect, Tags },
  props: {
    url: String,
    isLoading: Boolean,
    show: Boolean,
    onHide: Function,
    onSubmit: Function,
    defaultSettings: Object,
    isMultiple: Boolean,
  },
  data: () => ({
    redirect_url: "",
    redirect_delay: 1000,
    scroll_percentage: 15,
    click_selector: "a.survey_button",
    show_selector: "",
    redirect_flow: "delay",
    enabled: false,
    redirect_percent: 0,
    settingsForCopy: null,
    search_domains: "",
    tags: [],
  }),
  computed: {
    ...mapState({
      list: (state) => state.domains.domains_list_for_settings,
    }),
    flowOptions: () => ["delay", "scroll", "click", "show"],
  },
  methods: {
    ...mapActions({
      loadData: `domains/${TYPES.GET_DOMAINS_FOR_SETTINGS}`,
    }),
    onSaveClick: function (e) {
      e.preventDefault();
      this.$refs.ModalSubmit.click();
    },
    onSave: function (e) {
      e.preventDefault();
      const urlPattern = /^(http|https):\/\/[^ "]+$/;
      if (!urlPattern.test(this.redirect_url)) {
        this.$toaster.warning("Incorect redirect url.");
        return;
      }

      const data = {
        redirect_url: this.redirect_url,
        redirect_flow: this.redirect_flow,
        enabled: this.enabled,
        redirect_percent: this.redirect_percent,
        tags: this.$refs.tags.getTagsList(),
        has_wrong_selector: false,
      };
      switch (this.redirect_flow) {
        case "delay":
          data.redirect_delay = this.redirect_delay;
          break;
        case "scroll":
          data.scroll_percentage = this.scroll_percentage;
          break;
        case "click":
          data.click_selector = this.click_selector;
          break;
        case "show":
          data.show_selector = this.show_selector;
          break;
      }
      this.onSubmit({ settings: data });
    },
    onOpen: function () {
      this.$refs["modal"].show();
    },
    onCancel: function () {
      this.$refs["modal"].hide();
      this.redirect_url = "";
      this.redirect_delay = 1000;
      this.scroll_percentage = 15;
      this.click_selector = "a.survey_button";
      this.show_selector = "";
      this.redirect_flow = "delay";
      this.enabled = false;
      this.redirect_percent = 0;
      this.settingsForCopy = null;
      this.search_domains = "";
      this.tags = [];
    },
    onChangeSearchDomain: function (e) {
      e.preventDefault();
      this.onWaitChange();
    },
    onWaitChange: function () {
      if (this.search_domains.length >= 2 || this.search_domains === "") {
        this.loadData(`domain=${this.search_domains}`);
      }
    },
    setDefaultSettings() {
      if (this.defaultSettings) {
        this.redirect_url = this.defaultSettings.redirect_url;
        this.redirect_delay = this.defaultSettings.redirect_delay;
        this.scroll_percentage = this.defaultSettings.scroll_percentage;
        this.click_selector = this.defaultSettings.click_selector;
        this.show_selector = this.defaultSettings.show_selector;
        this.redirect_flow = this.defaultSettings.redirect_flow;
        this.enabled = this.defaultSettings.enabled;
        this.redirect_percent = this.defaultSettings.redirect_percent;
        this.tags = this.defaultSettings.tags || [];
      }
    },
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.onOpen();
        this.setDefaultSettings();
        this.isMultiple && this.loadData(`limit=10&ordering=last_visit_at`);
      } else {
        this.onCancel();
      }
    },
    defaultSettings(newValue) {
      if (newValue) {
        this.redirect_url = newValue.redirect_url;
        this.redirect_delay = newValue.redirect_delay;
        this.scroll_percentage = newValue.scroll_percentage;
        this.click_selector = newValue.click_selector;
        this.show_selector = newValue.show_selector;
        this.redirect_flow = newValue.redirect_flow;
        this.enabled = newValue.enabled;
        this.redirect_percent = newValue.redirect_percent;
        this.tags = newValue.tags || [];
      }
    },
    settingsForCopy(newValue) {
      if (newValue && newValue.settings) {
        this.redirect_url = newValue.settings.redirect_url;
        this.redirect_delay = newValue.settings.redirect_delay;
        this.scroll_percentage = newValue.settings.scroll_percentage;
        this.click_selector = newValue.settings.click_selector;
        this.show_selector = newValue.settings.show_selector;
        this.redirect_flow = newValue.settings.redirect_flow;
        this.enabled = newValue.settings.enabled;
        this.redirect_percent = newValue.settings.redirect_percent;
        this.tags = newValue.settings.tags || [];
      }
    },
  },
  created: function () {
    this.onWaitChange = debounce(this.onWaitChange, 500);
    this.setDefaultSettings();
  },
};
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
</style>
